export default {
  // namespaced: true,
  state: {
    CandidateSelected: {
      selectId: []
    }
  },
  mutations: {
    // selected
    ADD_CANDIDATE_SELECTED (store, id) {
      if (!store.CandidateSelected.selectId.includes(id)) {
        store.CandidateSelected.selectId.push(id)
      }
    },
    REMOVE_CANDIDATE_SELECTED (store, id) {
      let index = store.CandidateSelected.selectId.indexOf(id)
      if (index !== -1) store.CandidateSelected.selectId.splice(index, 1)
    },
    RESET_CANDIDATE_SELECTED (store) {
      store.CandidateSelected.selectId = []
    }
  },
  getters: {
    // selectId
    getCandidateSelectedIds: (store, getters) => {
      return store.CandidateSelected.selectId
    },
    getCandidateSelected: (store, getters) => {
      return store.CandidateSelected.selectId.map((id) => {
        return getters['entities/candidates/query']().find(id)
      })
    }
  },
  actions: {
    addCandidateSelected ({commit, dispatch, getters, state}, id) {
      commit('ADD_CANDIDATE_SELECTED', id)
    },
    removeCandidateSelected ({commit, dispatch, getters, state}, id) {
      commit('REMOVE_CANDIDATE_SELECTED', id)
    },
    toggleCandidateSelected ({commit, dispatch, getters, state}, id) {
      let index = state.CandidateSelected.selectId.indexOf(id)
      if (index !== -1) dispatch('removeCandidateSelected', id)
      else dispatch('addCandidateSelected', id)
    },
    resetCandidateSelected ({commit, dispatch, getters, state}) {
      commit('RESET_CANDIDATE_SELECTED')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/CandidateSelected.js